<template>
  <div id="tests" class="lifestyle-dashboard lifestyle-dashboard-v3">
    <div
      style="
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        max-width: 850px;
        margin: 0 auto;
      "
    >
      <img src="/static/img/tests.png" style="width: 300px" />
      <h3
        style="
          font-size: 36px;
          font-weight: bold;
          margin-top: 10px;
          margin-bottom: 10px;
        "
        class="dark-inverted"
      >
        Testler
      </h3>
      <p style="font-size: 20px; text-align: center">
        "Şaşırtıcı derecede doğru" olarak tanımlanan, milyonlarca insanın
        cevapladığı bir sistemle sen de, öğrenme sitillerini, eğitim destek
        sistemini, çalışma davranışlarını, zaman yönetimini, öğrenme
        motivasyonunu anlamaya çalış.
      </p>
    </div>

    <div class="blog-text mb-5" v-for="(item, index) in tests">
      <div class="d-flex justify-content-between align-items-center">
        <h4
          class="d-flex mt-0 mb-0 dark-inverted"
          style="padding: 10px 0px; font-size: 20px; font-weight: bold"
        >
          {{ item.title }}
        </h4>
        <span>
          <span class="d-block moment-date dark-inverted"
            >{{ moment(item.created_at).fromNow() }} -
            <strong class="dark-inverted"
              >{{ item.answer_count }}/{{ item.question_count }}</strong
            ></span
          >
        </span>
      </div>
      <ul class="list-view list-view-v3">
        <li class="list-view-item" v-for="part in item.parts">
          <div class="d-flex justify-content-between mb-3">
            <span class="d-flex align-items-center">
              <a
                href="javascript:;"
                v-if="part.question_count != part.answer_count"
                style="padding: 5px 9px; height: 28px"
                @click="
                  $router.push({
                    name: 'TestDetail',
                    params: { test_id: item.test_id, part_id: part.part_id },
                  })
                "
                class="button h-button is-warning is-rounded is-outlined"
                ><strong
                  class="dark-inverted"
                  style="margin-right: 10px; font-size: 19px"
                  >{{ part.title }}</strong
                >
                <span class="dark-inverted">{{
                  part.answer_count == 0
                    ? "Çözmeye Başla"
                    : part.answer_count == part.question_count
                    ? "Tamamlandı"
                    : "Çözmeye Devam Et"
                }}</span></a
              >
              <div class="dark-inverted" v-else>
                Tamamlandı
                <i
                  class="lnil lnil-checkmark-circle"
                  style="color: #06d6b5"
                ></i>
              </div>
            </span>
            <span class="dark-inverted"
              >{{ part.answer_count }}/{{ part.question_count }}</span
            >
          </div>
          <div class="progress is-success">
            <div
              class="progress-bar"
              role="progressbar"
              style="height: 100%; background: #06d6b5"
              :style="
                'width: ' +
                (part.answer_count / part.question_count) * 100 +
                '%; background-color: ' +
                (part.answer_count != part.question_count
                  ? 'orange'
                  : '#06d6b5')
              "
              aria-valuenow="25"
              aria-valuemin="0"
              aria-valuemax="100"
            ></div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment/min/moment-with-locales";
moment.locale("tr");
export default {
  name: "Tests",
  data() {
    return {
      tests: [],
      moment,
    };
  },
  methods: {},
  created() {
    axios.get("account/getTests").then((res) => {
      this.tests = res.data.data;
    });
  },
};
</script>


// WEBPACK FOOTER //
// src/pages/Tests.vue